
export const newWebSocket = {
  websocket: null,
  heartbeat_timer: null, // 用于心跳检测
  active_close: false, // 是否主动关闭
  reconnect_timer: null, // 重连定时器
  reconnect_count: 0, // 重连次数
  max_reconnect_count: 5, // 最大重连次数
  reconnect_interval: 5000, // 重连间隔（毫秒）
  is_connecting: false, // 是否正在连接中
  
  init: (params) => {
    // 如果正在连接中，直接返回
    if (newWebSocket.is_connecting) {
      console.log('正在连接中，跳过重复连接')
      return
    }
    
    // 如果已有连接且状态正常，不重复创建
    if (newWebSocket.websocket && newWebSocket.websocket.readyState === WebSocket.OPEN) {
      console.log('WebSocket已连接，无需重复创建')
      return
    }
    
    newWebSocket.is_connecting = true
    newWebSocket.websocket = new WebSocket(params.url)
    
    newWebSocket.websocket.onopen = (data) => {
      console.log('WebSocket连接成功')
      newWebSocket.is_connecting = false
      newWebSocket.reconnect_count = 0 // 重置重连次数
      newWebSocket.heartbeat()
      if (params.onopen) {
        params.onopen('webSocket已连接', data)
      }
    }
    
    newWebSocket.websocket.onmessage = (data) => {
      if (params.onmessage) {
        params.onmessage(data.data)
      }
    }
    
    newWebSocket.websocket.onclose = (event) => {
      console.log('WebSocket连接关闭', event.code, event.reason)
      newWebSocket.is_connecting = false
      clearInterval(newWebSocket.heartbeat_timer)
      
      if (newWebSocket.active_close) {
        if (params.onclose) {
          params.onclose('连接已手动关闭')
        }
      } else {
        // 检查是否需要重连
        if (newWebSocket.reconnect_count < newWebSocket.max_reconnect_count) {
          newWebSocket.reconnect(params)
          if (params.onclose) {
            params.onclose(`连接已关闭, 正在重连 (${newWebSocket.reconnect_count + 1}/${newWebSocket.max_reconnect_count})`)
          }
        } else {
          console.log('达到最大重连次数，停止重连')
          if (params.onclose) {
            params.onclose('连接已关闭，重连次数已达上限')
          }
        }
      }
    }
    
    newWebSocket.websocket.onerror = (error) => {
      console.error('WebSocket连接错误', error)
      newWebSocket.is_connecting = false
      clearInterval(newWebSocket.heartbeat_timer)
      
      if (params.onerror) {
        params.onerror('连接发生错误！等待重连')
      }
    }
  },
  
  heartbeat: () => {
    console.log('启动心跳检测')
    if (newWebSocket.heartbeat_timer) {
      clearInterval(newWebSocket.heartbeat_timer)
    }
    newWebSocket.heartbeat_timer = setInterval(function (){
      if (newWebSocket.websocket && newWebSocket.websocket.readyState === WebSocket.OPEN) {
        newWebSocket.websocket.send('heartbeat')
      } else {
        console.log('WebSocket未连接，停止心跳')
        clearInterval(newWebSocket.heartbeat_timer)
      }
    }, 10000)
  },
  
  reconnect: (params) => {
    if (newWebSocket.reconnect_timer) {
      clearTimeout(newWebSocket.reconnect_timer)
    }
    
    newWebSocket.reconnect_count++
    console.log(`执行重连，第${newWebSocket.reconnect_count}次`)
    
    newWebSocket.active_close = false
    
    // 清理现有连接
    if (newWebSocket.websocket) {
      newWebSocket.websocket.onopen = null
      newWebSocket.websocket.onmessage = null
      newWebSocket.websocket.onclose = null
      newWebSocket.websocket.onerror = null
      newWebSocket.websocket.close()
      newWebSocket.websocket = null
    }
    
    // 延迟重连，避免频繁重连
    newWebSocket.reconnect_timer = setTimeout(() => {
      newWebSocket.init(params)
    }, newWebSocket.reconnect_interval)
  },
  
  close: () => {
    console.log('手动关闭WebSocket连接')
    clearInterval(newWebSocket.heartbeat_timer)
    clearTimeout(newWebSocket.reconnect_timer)
    newWebSocket.active_close = true
    newWebSocket.is_connecting = false
    newWebSocket.reconnect_count = 0
    
    if (newWebSocket.websocket) {
      newWebSocket.websocket.onopen = null
      newWebSocket.websocket.onmessage = null
      newWebSocket.websocket.onclose = null
      newWebSocket.websocket.onerror = null
      newWebSocket.websocket.close()
      newWebSocket.websocket = null
    }
  },
  
  // 重置重连状态
  resetReconnect: () => {
    newWebSocket.reconnect_count = 0
    newWebSocket.is_connecting = false
  }
}

